

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Typography, Grid, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Icon } from "@iconify/react";
import { initiativeGetById } from '../initiative.service';
import Loader from '../../../../components/loader';

const baseUrl = process.env.REACT_APP_AZURE_IMAGE_BASE_URL
const sasToken = process.env.REACT_APP_AZURE_SAS_TOKEN

const InitiativeView = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [initiativeData, setinitiativeData] = useState({});

    useEffect(() => {
        getInitiativeData();
    }, []);

    const getInitiativeData = async () => {
        try {
            const data = await initiativeGetById(id);
            setinitiativeData(data.data);
        } catch (error) {
            console.error('Error fetching user type by ID', error);
        }
    };

    return (
        <div>
            <Grid container alignItems={'center'}>
                <Grid size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3 }}>
                    <Typography style={{ fontSize: 30, fontWeight: 700 }}>Initiative View</Typography>
                </Grid>
                <Grid size={{ xs: 6, sm: 7.5, md: 8.5, lg: 8.5, xl: 8.5 }} textAlign={'end'}>
                    <Button variant="contained" className='createBtn' type="submit" onClick={() => { setLoading(true); navigate(`/addInitiative/${id}?type=edit`) }}>Edit</Button>
                </Grid>
                <Grid size={{ xs: 2, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }} textAlign={'end'}>
                    <Icon icon="ei:arrow-left" onClick={() => navigate('/initiative')} width="30" height="30" className='backIcon'  />
                </Grid>
            </Grid>

            <Grid container mt={2} rowGap={4}>
                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                    <Grid container>
                        <Grid size={{ xs: 6, sm: 3, md: 3, lg: 3, xl: 3 }}>
                            <Typography className='contentLeft'>Solution</Typography>
                        </Grid>
                        <Grid size={{ xs: 1, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}>
                            <Typography className='contentLeft'> :</Typography>
                        </Grid>
                        <Grid size={{ xs: 5, sm: 8, md: 8, lg: 8, xl: 8 }}>
                            <Typography className='contentRight'> {initiativeData?.solution?.name ?? "-"} </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                    <Grid container>
                        <Grid size={{ xs: 6, sm: 3, md: 3, lg: 3, xl: 3 }}>
                            <Typography className='contentLeft'>Initiative Name</Typography>
                        </Grid>
                        <Grid size={{ xs: 1, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}>
                            <Typography className='contentLeft'> :</Typography>
                        </Grid>
                        <Grid size={{ xs: 5, sm: 8, md: 8, lg: 8, xl: 8 }}>
                            <Typography className='contentRight'>{initiativeData?.name ?? "-"} </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container mt={2}>
                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                    <Grid container >
                        <Grid size={{ xs: 6, sm: 3, md: 3, lg: 3, xl: 3 }}>
                            <Typography className='contentLeft'>Country  </Typography>
                        </Grid>
                        <Grid size={{ xs: 1, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}>
                            <Typography className='contentLeft'> :</Typography>
                        </Grid>
                        <Grid size={{ xs: 5, sm: 8, md: 8, lg: 8, xl: 8 }}>
                            <Typography className='contentRight'>{initiativeData?.country?.name ?? "-"}</Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                    <Grid container >
                        <Grid size={{ xs: 6, sm: 3, md: 3, lg: 3, xl: 3 }}>
                            <Typography className='contentLeft'>Initiative Link  </Typography>
                        </Grid>
                        <Grid size={{ xs: 1, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}>
                            <Typography className='contentLeft'> :</Typography>
                        </Grid>
                        <Grid size={{ xs: 5, sm: 8, md: 8, lg: 8, xl: 8 }}>
                            <Typography className='contentRight'> {initiativeData?.initiativeLink ?? "-"}  </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container mt={2}>
                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                    <Grid container >
                        <Grid size={{ xs: 6, sm: 3, md: 3, lg: 3, xl: 3 }}>
                            <Typography className='contentLeft'>Label</Typography>
                        </Grid>
                        <Grid size={{ xs: 1, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}>
                            <Typography className='contentLeft'> :</Typography>
                        </Grid>
                        <Grid size={{ xs: 5, sm: 8, md: 8, lg: 8, xl: 8 }}>
                            <Typography className='contentRight'> {initiativeData?.label ?? "-"} </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                    <Grid container mt={2}>
                        <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
                            <Typography className='contentLeft'> Description </Typography>
                        </Grid>
                        <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
                            <Typography className='contentLeft'> :</Typography>
                        </Grid>
                        <Grid size={{ xs: 5, sm: 5, md: 8, lg: 8, xl: 8 }}>
                            <div className="contentRight"> <span style={{ padding: 0 }} dangerouslySetInnerHTML={{ __html: initiativeData?.description }} /> </div>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            {/* <Grid container mt={2}>
                <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
                    <Typography className="contentLeft">Image</Typography>
                </Grid>
                <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
                    <Typography className='contentLeft'> :</Typography>
                </Grid>
                <Grid size={{ xs: 5, sm: 5, md: 8, lg: 8, xl: 8 }}>
                    {initiativeData?.imageUrl ? (
                        <img src={`${baseUrl}/${initiativeData.imageUrl}?${sasToken}`} alt="None" width={100} height={100} onError={(e) => {
                            e.target.onerror = null;
                            e.target.style.display = 'none';
                            e.target.parentNode.textContent = '-';
                        }}
                        />
                    ) : (
                        '-'
                    )}
                </Grid>
            </Grid> */}

            <Grid container mt={2}>
                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                    <Grid container >
                        <Grid size={{ xs: 6, sm: 3, md: 3, lg: 3, xl: 3 }}>
                            <Typography className='contentLeft'>Image</Typography>
                        </Grid>
                        <Grid size={{ xs: 1, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}>
                            <Typography className='contentLeft'> :</Typography>
                        </Grid>
                        <Grid size={{ xs: 5, sm: 8, md: 8, lg: 8, xl: 8 }}>
                            {initiativeData?.imageUrl ? (
                                <img src={`${baseUrl}/${initiativeData.imageUrl}?${sasToken}`} alt="None" width={100} height={100} onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.style.display = 'none';
                                    e.target.parentNode.textContent = '-';
                                }}
                                />
                            ) : (
                                '-'
                            )}
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>


            {loading && <Loader />}
        </div>
    );
};

export default InitiativeView;
